/* Publish by EComposer at 2026-03-16 18:11:57*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-kiu4ewljh5i"]=  window.__ectimmers["ecom-kiu4ewljh5i"] || {};
if(!this.settings||!this.$el||this.isLive)return;const t=this.$el;let e=t.querySelectorAll('script:not([type="application/json"])');e.length>0&&e.forEach(function(i){let n=document.createElement("script");n.type="text/javascript",n.innerText=i.innerText,i.src&&(n.src=i.src),t.appendChild(n),i.remove()})

                    });
                    
                        document.querySelectorAll('.ecom-kiu4ewljh5i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kiu4ewljh5i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-72uphddwgh7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-72uphddwgh7', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-93w3ru5bw2"]=  window.__ectimmers["ecom-93w3ru5bw2"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-93w3ru5bw2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-93w3ru5bw2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-71zjmt0gjro').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-71zjmt0gjro', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iaw9ty1em9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iaw9ty1em9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9zsfbonxv0p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9zsfbonxv0p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hq4of06usd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hq4of06usd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8wen70nii1u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8wen70nii1u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bfrddquobvs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bfrddquobvs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q7kvzbtiox').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q7kvzbtiox', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tnyy3nwczqa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tnyy3nwczqa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mzo5mrwwhe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mzo5mrwwhe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ahae791xa1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ahae791xa1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vllp3iju45c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vllp3iju45c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-04mzumtqufq5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-04mzumtqufq5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ihzxteiihv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ihzxteiihv', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fjb6fdirvqj"]=  window.__ectimmers["ecom-fjb6fdirvqj"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=e.querySelector(".ecom-element.ecom-base-image"),o=e.closest(".core__row--columns");s&&(i(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-fjb6fdirvqj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fjb6fdirvqj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jad338g4kph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jad338g4kph', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mdyt3xd7ci').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mdyt3xd7ci', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4l4axcxm5g6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4l4axcxm5g6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-75fxyxipgap').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-75fxyxipgap', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r1mrxxljew').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r1mrxxljew', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ifoyyvagj4k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ifoyyvagj4k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5g9fjb1dmsd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5g9fjb1dmsd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r5gii4gi5r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r5gii4gi5r', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v827q72uz4j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v827q72uz4j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
// document.addEventListener("DOMContentLoaded", function () {
//     const cards = document.querySelectorAll(".winemaker-card");

//     cards.forEach((card) => {
//       const image = card.querySelector(".winemaker-image");
//       const info = card.querySelector(".winemaker-info");

//       if (!image || !info) return; // safety check

//       // Initial hide via JS (in case CSS not working)
//       info.style.opacity = "0";
//       info.style.display = "none";
//       info.style.transition = "opacity 0.3s ease";

//       image.addEventListener("mouseenter", () => {
//         info.style.display = "block";
//         setTimeout(() => {
//           info.style.opacity = "1";
//         }, 10); // slight delay for transition
//       });

//       image.addEventListener("mouseleave", () => {
//         info.style.opacity = "0";
//         setTimeout(() => {
//           info.style.display = "none";
//         }, 300); // match transition time
//       });
//     });
//   });





// Set default active on first card
document.querySelector('.winemaker-card')?.classList.add('active');

document.querySelectorAll('.winemaker-card').forEach(card => {
  card.addEventListener('mouseenter', () => {
    document.querySelectorAll('.winemaker-card').forEach(c => c.classList.remove('active'));
    card.classList.add('active');
  });
});


} catch(error){console.error(error);}